import devices from '../components/canvas-editor-v2/assets/devices.json';

export const getDefaultProjectDataV2 = (deviceInfo = devices[0]) => ({
  version: '5.3.0',
  objects: [],
  background: 'white',
  deviceInfo,
});
